export function setLocalStorageItem<T>(key: string, value: T): void {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error(`Error al guardar en localStorage la clave "${key}":`, error);
  }
}

export function getLocalStorageItem<T>(key: string): T | null {
  try {
    const serializedValue = localStorage.getItem(key);
    if (serializedValue === null) {
      return null;
    }
    return JSON.parse(serializedValue);
  } catch (error) {
    console.error(`Error al leer de localStorage la clave "${key}":`, error);
    return null;
  }
}

export function removeLocalStorageItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(
      `Error al eliminar de localStorage la clave "${key}":`,
      error,
    );
  }
}
